import { render, staticRenderFns } from "./step_productos.vue?vue&type=template&id=66d2d1de"
import script from "./step_productos.vue?vue&type=script&lang=js"
export * from "./step_productos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports